<template>
    <div class="information-box"><slot /></div>
</template>

<script>
export default {
    name: 'InfoBox',
}
</script>

<style lang="scss" scoped>
.information-box {
    background: $color-gray-lighter;
    padding: 0.5rem;
    margin-bottom: 1rem;
    line-height: 1.6;
    font-size: $fs-label;
}
</style>
